import { baseApi } from "configs/store-query";
import { TUserApiRequest, TUserApiResponse } from "apis/user/types/user-api";
import { USER } from "constants/tags";

const BASE_PATH = "/users";

export const userApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query({
      query: (config) => ({
        url: `${BASE_PATH}`,
        ...config,
      }),
      providesTags: [USER],
    }),
    getUser: build.query({
      query: ({ path, ...config }) => ({
        url: `${BASE_PATH}/${path.id}`,
        ...config,
      }),
      providesTags: [USER],
    }),
    getUserSelf: build.query<TUserApiResponse, TUserApiRequest>({
      query: (config) => ({
        url: `${BASE_PATH}/self`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER],
    }),
    getSavedUsers: build.query({
      query: (config) => ({
        url: `${BASE_PATH}/saved`,
        ...config,
      }),
      providesTags: [USER],
    }),
  }),
});
